import productTileTemplate from '../../sections/collection/productTileTemplateNosto';
import { escapeHtml } from '../../core/helpers';

// Not used in this version
const getHistory = () => {
  return '';
};

const getKeywords = (keywords) => {
  const keywords_html = keywords.map(hit => {
    const keyword_content = hit._highlight?.keyword || hit.keyword;

    // We don't want to show the keyword if it's 100% identical to the search term to avoid rage clicks since it will provide the same suggestions, but we still want to keep it in the DOM
    let show_keyword = true;
    if (document.getElementById('search').value.toLowerCase() === hit.keyword.toLowerCase()) {
      show_keyword = false;
    }

    // Encode the json due to special characters that would break the html (new year's eve for instance)
    // Hit value example: {"keyword":"new year's eve","_highlight":{"keyword":"<strong>new</strong> <strong>year</strong>'s eve"}}
    const json_hit = escapeHtml(JSON.stringify(hit));
    return `
      <div class="ns-autocomplete-keyword${(show_keyword) ? '' : ' hidden'}" data-ns-hit="${json_hit}" data-testid="keyword">
        <div class="ns-autocomplete-keyword__wrapper">
          <div class="ns-autocomplete-keyword__content">
            <div class="ns-autocomplete-keyword__icon">
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" aria-label="Keyword icon">
                <path d="M16.041 15.856c-0.034 0.026-0.067 0.055-0.099 0.087s-0.060 0.064-0.087 0.099c-1.258 1.213-2.969 1.958-4.855 1.958-1.933 0-3.682-0.782-4.95-2.050s-2.050-3.017-2.050-4.95 0.782-3.682 2.050-4.95 3.017-2.050 4.95-2.050 3.682 0.782 4.95 2.050 2.050 3.017 2.050 4.95c0 1.886-0.745 3.597-1.959 4.856zM21.707 20.293l-3.675-3.675c1.231-1.54 1.968-3.493 1.968-5.618 0-2.485-1.008-4.736-2.636-6.364s-3.879-2.636-6.364-2.636-4.736 1.008-6.364 2.636-2.636 3.879-2.636 6.364 1.008 4.736 2.636 6.364 3.879 2.636 6.364 2.636c2.125 0 4.078-0.737 5.618-1.968l3.675 3.675c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414z"></path>
              </svg>
            </div>
            <div class="ns-autocomplete-keyword__contentBody">
              <div class="ns-autocomplete-keyword__contentTitle">
                <span>${keyword_content}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }).join('');

  return `
    <section class="ns-autocomplete-keywords">
      <div class="ns-autocomplete-header visually-hidden">${window.theme.strings.keywords}</div>
      ${keywords_html}
    </section>
  `;
};

const getProducts = (hits, is_autocomplete = true) => {
  const MAX_PRODUCTS = 6;

  const products_html = hits.slice(0, MAX_PRODUCTS).map((hit) => {
    const json_hit = escapeHtml(JSON.stringify({
      productId: hit?.original_hit?.productId || hit?.product_id,
      url: hit?.original_hit?.url || hit?.url,
    }));

    // When is_autocomplete is false, it means we come from the no-results recommendations, it isn't an autocomplete result so we don't want to add the data attributes
    const data_attributes = (is_autocomplete) ? ` data-ns-hit="${json_hit}" data-testid="product"` : '';

    return `<div class="ns-autocomplete-product-tile"${data_attributes}>
      ${productTileTemplate(hit, {
        is_slider: false,
        is_simplified: is_autocomplete, // complicated to have a simplified version of the product tile in autocomplete
        has_swatches: true,
        has_quickview: !is_autocomplete, // complicated to have a quickview in autocomplete, see how we did it for the swatches in suggestion-search.js if needed in the future
        is_search: true,
        is_lookbook: false,
        has_animations: false,
      })}
    </div>`;
  }).join('');

  const see_all_button = (is_autocomplete && hits.length >= MAX_PRODUCTS) ? `<div class="ns-autocomplete-submit"><button type="submit" class="ns-autocomplete-button btn btn--primary" astr-autocomplete-see-all>${window.theme.strings.seeAllResults}</button></div>` : '';
  
  return `
    <div class="ns-autocomplete-header visually-hidden">${window.theme.strings.products}</div>
    <div id="${window.theme.search.nosto_search_no_results_placement}" class="ns-autocomplete-products-list nosto_element nosto_dynamic_element">${products_html}</div>
    ${see_all_button}
  `;
};

/*
  Returns the HTML of the formatted search suggestions (keywords) and product suggestions
 */
export default (autocomplete_data, products_only = false, show_see_all_button = true) => {
  try {
    if (typeof autocomplete_data === 'undefined' || autocomplete_data === null) {
      console.warn('[ASTR] Autocomplete data is undefined or null.');
      return '';
    }

    console.log('[ASTR] autocomplete data', autocomplete_data);

    const has_keywords = autocomplete_data?.keywords?.hits.length > 0 ?? 0;
    const has_products = autocomplete_data?.products?.hits.length > 0 ?? 0;
    const has_history = false; // history.length > 0;

    if (products_only) {
      return (has_products) ? getProducts(autocomplete_data?.products?.hits ?? [], show_see_all_button) : '';
    }

    return `
      <div class="ns-autocomplete-results">
        ${(has_keywords == false && has_products == false && has_history) ? getHistory() : ''}
        ${(has_keywords) ? getKeywords(autocomplete_data?.keywords?.hits ?? []) : ''}
        ${(has_products) ? getProducts(autocomplete_data?.products?.hits ?? [], show_see_all_button) : ''}
      </div>
    `;
  } catch (error) {
    console.error('[ASTR] Error in autocomplete-template:', error);
    return '';
  }
};
